<template>
    <div>

      <el-button type="primary" size="mini" @click="hide">全屏显示/恢复</el-button>
      <div id="filter">
        <el-row>
          标题关键字：<el-input v-model="title" size="mini" style="width: 200px"></el-input> <el-button type="primary" size="small"  @click="getTradeData">搜索</el-button>
        </el-row>

        <div class="block" align="left" style="margin-left: 400px; color: #000">
          <span class="demonstration"></span>
          <el-pagination style="color: #000"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="pageObject.pageCurrent"
                         :page-sizes="[50, 100, 1000, 2000, 5000]"
                         :page-size="pageObject.pageSize"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="pageObject.rowCount">
          </el-pagination>
        </div>
      </div>


      <el-row>
        <el-col :span="24">
          <el-table border style="font-size: 12px" :data="tradeData" :header-cell-style="{background:'#F2F6FC',color:'#000'}" :row-style="changeRed">
            <el-table-column  label="序号"
                              type="index"
                              :index="indexMethod">
            </el-table-column>
            <el-table-column  prop="tid" label="订单号" width="140px"></el-table-column>
            <el-table-column  prop="trueName" label="收件人姓名（必填）" width="120px"></el-table-column>
            <el-table-column  prop="trueMobile" label="收件人电话/手机（必填）" width="120px"></el-table-column>
            <el-table-column  prop="address" label="收件人地址（必填）" ></el-table-column>
            <el-table-column  prop="title" label="物品名称" width="240px"></el-table-column>
            <el-table-column  prop="" label="运费" width="80px"></el-table-column>
            <el-table-column  prop="" label="总金额（必填）" width="80px"></el-table-column>
            <el-table-column  prop="payment" label="折后金额（必填）" width="80px"></el-table-column>
            <el-table-column  prop="" label="快递单号" width="80px"></el-table-column>
            <el-table-column  prop="" label="买家备注" width="160px"></el-table-column>

          </el-table>
        </el-col>
      </el-row>
    </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
  import {hideLoading, showLoading} from "../api/loading";

    export default {
      name: "Love",
      data(){
          return{
            display:1,
            title:'',
            tradeData:[{tid:'\'3003773043320319446',trueName:'张小姐',trueMobile:'15712178480',address:'广东省 深圳市 宝安区 福永街道金菊路鹏飞大厦【配送拨打:15712178480转5426】',
              title:'建构25g*1', total:'120.3'}],
            pageObject: {
              pageCurrent: 1,
              rowCount: 0,
              pageSize: 100,
            },
          }
      },
      methods:{
        hide:function(){
          this.display++;
          if(this.display % 2 == 0){
            window.document.getElementById("left").style.display = 'none';
            window.document.getElementById("top").style.display = 'none';
            window.document.getElementById("filter").style.display = 'none';
          }else {
            window.document.getElementById("left").style.display = 'block';
            window.document.getElementById("top").style.display = 'block';
            window.document.getElementById("filter").style.display = 'block';
          }

        },
        indexMethod(index)
        {
          return index + 1;
        },
        //改变pageSize
        handleSizeChange: function (val) {
          this.pageObject.pageSize = val;
          this.getTradeData();
        },
        //当前页面改变
        handleCurrentChange: function (val) {
          this.pageObject.pageCurrent = val;
          this.getTradeData();
        },
        getTradeData(){
          let param={
              nick: storage.get('nick'),
              title: this.title,
              pageCurrent: this.pageObject.pageCurrent,
              rowCount: this.pageObject.rowCount,
              pageSize: this.pageObject.pageSize,
          }
          $api.post("/custom/love", param, response=>{
            let dataResult = response.data;
            console.log(dataResult);
            if(dataResult.state == 1){
              this.tradeData = dataResult.data.love;

              let pageObject = dataResult.data.pageObject;
              this.pageObject.rowCount = pageObject.rowCount;
              this.pageObject.pageSize = pageObject.pageSize;
            }else {
              this.$message.error(dataResult.message);
            }
          })
        },
        changeRed({row}) {
          if (row.numA != row.numB) { // 变颜色的条件
            return {
              backgroundColor: "red"  // 这个return的就是样式 可以是color 也可以是backgroundColor
            }
          }
        }
      },
      mounted(){
        this.getTradeData();
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/custom/Love.vue